import { render, staticRenderFns } from "./PersonPlacement.vue?vue&type=template&id=9a5b2296&"
import script from "./PersonPlacement.vue?vue&type=script&lang=js&"
export * from "./PersonPlacement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports